import React from 'react';

import { useHistory } from 'react-router';

import { Button } from 'components/Button';

import { useGlobalApp } from 'hooks/useGlobalApp';

import { oldToNewRoutePath, routes } from 'utils/routes';

export const NotFoundPage = () => {
  const history = useHistory();
  const { activeTenant } = useGlobalApp();

  // if this is an old route path, replace with new route path without having to do a page refresh
  // we need to remove the tenant slug, as it's not part of the old-to-new route mapping
  const curPath = history.location.pathname;
  const curPathWithoutTenantSlug = curPath.replace(`/${activeTenant.slug}`, '');
  const newPath = oldToNewRoutePath(curPathWithoutTenantSlug);

  if (newPath) {
    history.replace(newPath + history.location.hash);
    return null;
  }

  // console.error so e2e tests will fail if they encounter a 404 page
  console.error(`NotFound: no routes matching '${curPath}'`);
  return (
    <div style={{ height: '500px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '80px' }}>404</h1>
      <h1>Sorry, page not found.</h1>
      <br />
      <Button type="primary" onClick={() => history.push(routes.home())}>
        Return to Homepage
      </Button>
    </div>
  );
};
